import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=00516d87&scoped=true&"
import script from "./Car.vue?vue&type=script&lang=js&"
export * from "./Car.vue?vue&type=script&lang=js&"
import style0 from "./Car.vue?vue&type=style&index=0&id=00516d87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00516d87",
  null
  
)

export default component.exports